import React from 'react';
import Markdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ActionModal from 'components/Modal/ActionModal';

export interface ICloseConfirmationModal {
  onCancelClick: () => void;
}

const CloseConfirmationModal: React.FC<ICloseConfirmationModal> = ({ onCancelClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ActionModal
      cancelLabel={t('documents.edition.buttons.cancel')}
      confirmLabel={t('documents.edition.modal.cancel_modal.quit')}
      description={<Markdown>{t('documents.edition.modal.cancel_modal.message')}</Markdown>}
      icon={<i className="fa-light fa-xmark" />}
      onClose={onCancelClick}
      onConfirm={() => navigate({ pathname: '/documents/center' })}
      title={t('documents.edition.modal.cancel_modal.title')}
    />
  );
};

export default CloseConfirmationModal;